import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE, TYPE_ALL} from '../../../utils/DropdownOptionPropsUtils';

export const objectTypeOptionResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: TYPE_ALL
    },
    {
        name: 'FOLDER', value: 'folder'
    },
    {
        name: 'FILE', value: 'file'
    }
];